import React from 'react';
import { Link } from '@paypalcorp/pp-react';
export default ({ publicCredential, handleClickChange = () => { }, labelForChange = '' }) => {
    return (React.createElement("div", { className: "otpDisplayCredentials" },
        React.createElement("div", { className: "profileDisplayEmail", id: "displayEmail", "data-testid": "display-email" }, publicCredential),
        React.createElement("div", null,
            React.createElement(Link, { href: "#", className: "secondaryLink", id: "linkChangeEmail", "data-testid": "link-change-email", onClick: handleClickChange, style: { textAlign: 'right', whiteSpace: 'nowrap' }, tabIndex: "1" }, labelForChange))));
};
